var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVector56 = function SvgVector56(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.133 10.62h-3.84a.15.15 0 0 1-.15-.15V1.451a.15.15 0 0 0-.273-.085L1.134 14.095a.15.15 0 0 0 .124.235h4.05a.15.15 0 0 1 .15.15v8.108a.15.15 0 0 0 .272.088l8.525-11.82a.15.15 0 0 0-.122-.237Z",
    stroke: "#479DA6",
    strokeWidth: 1.75
  })));
};
export default SvgVector56;